import { Tchek } from './tchek';
import { TchekUser } from './user';

export class Roi {
    id: string;
    centerX: number;
    centerY: number;
    radius: number;
    picture: number;
    width: number;
    height: number;
    comment: string;
    isAuto: boolean;
    folder: string;
    tchek: Tchek;
    date: Date;
    user: TchekUser;
    type: string;
    location: string;
    isDelete: boolean;
    severity: string;
    toSync: boolean;
    vehicleId: string;
    isValidated: boolean;
    folderPtr: any;
    costType: string;
    cost: number;
    imageId: string
    // constructor(id: string, x: string, y: string, width: string, height: string, tchekId: string) {
    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/app/model/roi.ts